import ApiHelper from 'shared/utils/ApiHelper';
import { AxiosResponse } from 'axios';

const API_BASE = '/timesheet';

class UtilizationResultAppService {
  getUtilizationPlanAndResultList(proejctCd: string, fromDate: string, toDate: string): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/projects/${proejctCd}/utilization-plan-and-results?from=${fromDate}&to=${toDate}`;
    return ApiHelper.get(api);
  }

  getUtilizationPlanAndResultSumList(proejctCd: string, fromDate: string, toDate: string): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/projects/${proejctCd}/utilization-plan-and-results/sum?from=${fromDate}&to=${toDate}`;
    return ApiHelper.get(api);
  }

  getMonthCalendarList(yearMonth: string): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/calendars/param?yearMonth=${yearMonth}`;
    return ApiHelper.get(api);
  }

  rejectUtilizationResult(proejctCd: string, empNo: string, yyyymmdd: string): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/projects/${proejctCd}/emps/${empNo}/utilization-results/${yyyymmdd}/reject`;
    return ApiHelper.put(api, null);
  }

  getCorpConf(): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/corp-confs`;
    return ApiHelper.get(api);
  }

  getCloseSts(yearMonth: string): Promise<AxiosResponse<any>> {
    const api = `${API_BASE}/closests/${yearMonth}`;
    return ApiHelper.get(api);
  }
}

export default new UtilizationResultAppService();
